import React, { useState } from "react";
import classNames from "classnames";
import withNewNotifications from "../../../../../../../hocs/withNewNotifications";
import useNotificationsSearchInput from "../../../../../../../hooks/useNotificationsSearchInput";

import "./SearchInput.scss";

function SearchInput({ filters, setFilter, translate }) {
  const [value, handleChange] = useNotificationsSearchInput({
    filters,
    setFilter
  });

  const [focused, setFocused] = useState(false);

  return (
    <div
      className={classNames({
        "notification-filters-search-input": true,
        focused
      })}
    >
      <div className="icon">
        <i className="sqi sqi-search" aria-hidden="true" />
      </div>
      <input
        type="text"
        value={value}
        onChange={event => {
          handleChange(event.target.value);
        }}
        name="notifications-search"
        placeholder={translate("Search...")}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      {value ? (
        <i
          className="fal fa-times"
          onClick={() => {
            handleChange("");
          }}
        />
      ) : null}
    </div>
  );
}

export default withNewNotifications(SearchInput);
